import {
  useBreakpointRange,
  constants as angelouConstants,
} from "@newsela/angelou";
import { useRouter } from "next/router";

export const {
  breakpoints: {
    BreakpointRanges: { xsToSm, zeroToXs, smToMd },
  },
} = angelouConstants;

const useAnnotationFocusHandling = ({
  annotationCardRefs,
  contentBodyAnnotationRefs,
  setIsActivityPanelExpanded,
}) => {
  const router = useRouter();
  const { pathname, query } = router;

  const focusAnnotationCard = (annotationId) => {
    // Open activity panel if necessary.
    setIsActivityPanelExpanded(true);

    // Navigate to annotation screen.
    const href = {
      pathname,
      query: { ...query, activityPanel: "annotations" },
    };
    router.replace(href, null, { shallow: true });

    // The slight delay allows the screen to render before we attempt to focus the card.
    setTimeout(() => {
      const annotationCard = annotationCardRefs.current?.[annotationId];
      annotationCard?.focus();
    }, 150);
  };

  const currentBreakpointRange = useBreakpointRange();

  const focusContentBodyAnnotation = (annotationId) => {
    const isMobile = [zeroToXs, xsToSm, smToMd].includes(
      currentBreakpointRange,
    );

    // Close activity panel if necessary.
    if (isMobile) {
      setIsActivityPanelExpanded(false);
    }

    // The slight delay allows the screen to render before we attempt to focus the card.
    setTimeout(() => {
      const annotation = contentBodyAnnotationRefs.current?.[annotationId];
      annotation?.focus();
    }, 100);
  };

  return { focusAnnotationCard, focusContentBodyAnnotation };
};

export default useAnnotationFocusHandling;
